import { InputHTMLAttributes } from 'react';
import Select from '../Select';
import styles from './styles.module.css';

const perPageOptions = [20, 50, 100].map((pp) => ({
  label: `${pp}`,
  value: `${pp}`,
}));

type Props = Pick<InputHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'>;

/**
 * ページャーがある一覧を表示する画面において、1 ページあたりの件数を選択するセレクトボックス
 */
function SelectPageSize(props: Props) {
  return (
    <div className={styles.perPageContainer}>
      <span className={styles.perPageLabel}>表示件数</span>
      <div>
        <Select {...props} options={perPageOptions} variants={['fit']} />
      </div>
      <span className={styles.perPageLabel}>件</span>
    </div>
  );
}

export default SelectPageSize;
